import { useEffect, useState } from 'react';

import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useSnackNotificationContext } from '@sorare/core/src/contexts/snackNotification';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import {
  SESSION_STORAGE,
  useSessionStorage,
} from '@sorare/core/src/hooks/useSessionStorage';

export const usePackOpeningInterruptedSnackbar = () => {
  const { currentUser } = useCurrentUserContext();
  const [ongoingPackOpeningUserSlug, setOngoingPackOpeningUserSlug] =
    useSessionStorage(SESSION_STORAGE.ongoingPackOpeningUserSlug);
  const [initialPackOpeningInterruptedSlug] = useState(
    ongoingPackOpeningUserSlug
  );

  const { showNotification } = useSnackNotificationContext();
  const {
    flags: { disablePackOpeningInterruptedSnackbar = false },
  } = useFeatureFlags();

  const shouldDisplay =
    initialPackOpeningInterruptedSlug === currentUser?.slug &&
    !disablePackOpeningInterruptedSnackbar;

  useEffect(() => {
    if (shouldDisplay) {
      setTimeout(() => {
        showNotification('packOpeningInterrupted');
        setOngoingPackOpeningUserSlug(null);
      }, 2000);
    }
  }, [shouldDisplay, showNotification, setOngoingPackOpeningUserSlug]);
  return null;
};
